import React from 'react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { fetchConfig } from '../util/fetchConfig';
import {
  APP_ID_BUSINESS_BANKING,
  APP_ID_CREDIT_CARD_APP,
  APP_ID_ONE_REDI,
  APP_ID_PCA_APP
} from '../util/Constants';

export const LoadScript = () => {
  const [config, setConfig] = useState();
  const [configLoaded, setConfigLoaded] = useState();

  useEffect(async () => {
    const config = await fetchConfig();
    setConfig(config);
    setConfigLoaded(true);
  }, []);

  const getPvaConfig = (appId = APP_ID_PCA_APP) => {
    const pvaConfig = {
      [APP_ID_CREDIT_CARD_APP]: config?.cards,
      [APP_ID_ONE_REDI]: config?.cards?.oneRedi,
      [APP_ID_BUSINESS_BANKING]: config?.businessBanking,
      [APP_ID_PCA_APP]: config
    };
    return pvaConfig[appId];
  };

  const pvaConfig = configLoaded && getPvaConfig(window.urlParams.appId || APP_ID_PCA_APP);

  return configLoaded ? (
    <Helmet>
      <script
        v2
        id="Microsoft_Omnichannel_LCWidget"
        src="https://oc-cdn-public-gbr.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js"
        data-app-id={pvaConfig?.pvaDataAppId}
        data-lcw-version="prod"
        data-org-id={pvaConfig?.pvaDataOrgId}
        data-org-url={pvaConfig?.pvaDataOrgUrl}
        data-hide-chat-button="true"
        data-render-mobile="true"
        data-enable-lcw-autofill="true"
        data-color-override="#051441"
        data-font-family-override="Helvetica;Arial;sans-serif"
        data-customization-callback="lcw"
      ></script>
      <script>
        {`const defaultProps = {
            webChatContainerProps: {
              webChatStyles: {
                suggestedActionLayout: "flow"
              },
              renderingMiddlewareProps: {
                avatarStyleProps: {
                  backgroundImage:
                    "url(https://is3-ssl.mzstatic.com/image/thumb/Purple126/v4/b8/29/42/b8294254-a1cf-5b37-5e36-5ea52c670128/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/492x0w.png)",
                  backgroundSize: 'cover'
                },
                avatarTextStyleProps: {
                  display: 'none'
                }  
              },
              webChatProps: {
                overrideLocalizedStrings: {
                  ACTIVITY_BOT_SAID_ALT: "Virtual assistant says:"
                }
              }
            }
          };
          const footerProps = {
            footerProps: {
              controlProps: {
                hideDownloadTranscriptButton: true,
              }
            }
          };
          function lcw() {
            if(window.webkit) {
              return defaultProps;
            }
            return {
              ...defaultProps,
              ...footerProps,
            }
          }`}
      </script>
    </Helmet>
  ) : null;
};
